import { SIcon } from '@avalara/skylab-sdk/react';
import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { closeSystemErrorAndNavigate } from '../lib/side-effects/system';
import { CloseButton, Message, MessageContainer, NoClickContainer, SystemErrorContainer } from './styled/system-msg';

import type { SystemErrorOptions } from '@avalara/types/index';

type Props = {
  messaging: SystemErrorOptions;
};

const SystemErrorMessage = ({ messaging }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const onClose = () => dispatch(closeSystemErrorAndNavigate(history));

  return (
    <Fragment>
      <NoClickContainer onClick={onClose} />
      <SystemErrorContainer id='error-modal'>
        <MessageContainer offsetLeft={50}>
          <div>
            <CloseButton onClick={onClose} className='icon-cross'>
              <SIcon name='close' />
            </CloseButton>
            <h3 className='font-light'>{messaging.title}</h3>
            <Message>{messaging.message}</Message>
            {messaging.secondaryMessage?.map((msg) =>
              /[+]?[0-9 ().-]{10,}/.test(msg) ? (
                <span key={msg}>
                  &nbsp;
                  <a className='modal-link' href={`tel://${msg.replace(/[+ -().-]/g, '')}`}>
                    {msg}
                  </a>
                </span>
              ) : (
                <span key={msg}>&nbsp;{msg}</span>
              ),
            )}
            {messaging.html != null && (
              // biome-ignore lint/security/noDangerouslySetInnerHtml: legacy code
              <span data-ref='error.html-content' dangerouslySetInnerHTML={{ __html: messaging.html }} />
            )}
          </div>
        </MessageContainer>
      </SystemErrorContainer>
    </Fragment>
  );
};

export default SystemErrorMessage;
